import { defineMessages } from 'react-intl';

const translations = {
  sortSelection: {
    title: {
      id: 'dataGrid.sortSelection.title',
      defaultMessage: 'Sorting',
      description: 'Data grid sort selection title',
    },
    resetButton: {
      id: 'dataGrid.sortSelection.resetButton',
      defaultMessage: 'Reset sorting',
      description: 'The label of the reset sort button',
    },
  },
  sortDirections: {
    asc: {
      id: 'dataGrid.sortDirections.asc',
      defaultMessage: 'Ascending',
      description: 'Data grid sort direction asc title',
    },
    desc: {
      id: 'dataGrid.sortDirections.desc',
      defaultMessage: 'Descending',
      description: 'Data grid sort direction desc title',
    },
  },
  sortOptionSelectionItem: {
    cancelButton: {
      id: 'dataGrid.sortOptionSelectionItem.cancelButton',
      defaultMessage: 'Cancel',
      description: 'The label of the cancel sort option selection button',
    },
    saveButton: {
      id: 'dataGrid.sortOptionSelectionItem.saveButton',
      defaultMessage: 'Save',
      description: 'The label of the save sort option selection button',
    },
    createButton: {
      id: 'dataGrid.sortOptionSelectionItem.createButton',
      defaultMessage: 'Create',
      description: 'The label of the create sort option selection button',
    },
    newSortOptionHeader: {
      id: 'dataGrid.sortOptionSelectionItem.newSortOptionHeader',
      defaultMessage: 'Create sorting',
      description: 'The header title of the create sort option selection',
    },
  },
  filters: {
    label: {
      between: {
        id: 'dataGrid.filters.label.between',
        defaultMessage: '{name} in between {first} and {second}',
        description: 'Data grid between filter label',
      },
    },
  },
  columnSelection: {
    title: {
      id: 'dataGrid.columnSelection.title',
      defaultMessage: 'Columns',
      description: 'Data grid column selection title',
    },
    searchField: {
      placeholder: {
        id: 'dataGrid.columnSelection.searchField.placeholder',
        defaultMessage: 'Search',
        description: 'Data grid column selection search field placeholder',
      },
    },
    addColumn: {
      label: {
        id: 'dataGrid.columnSelection.addColumn.label',
        defaultMessage: 'Add column',
        description: 'Data grid column selection add column button label',
      },
    },
    availableColumns: {
      label: {
        id: 'dataGrid.columnSelection.availableColumns.label',
        defaultMessage: 'Available columns',
        description: 'Data grid column selection available columns label',
      },
    },
    selectedColumns: {
      label: {
        id: 'dataGrid.columnSelection.selectedColumns.label',
        defaultMessage: 'Selected columns',
        description: 'Data grid column selection selected columns label',
      },
    },
    resetButton: {
      id: 'dataGrid.columnSelection.resetButton',
      defaultMessage: 'Reset columns',
      description: 'The label of the reset kolommen button',
    },
  },
  addColumn: {
    title: {
      id: 'dataGrid.addColumn.title',
      defaultMessage: 'Add column',
      description: 'Data grid add new column title',
    },
    inputs: {
      name: {
        label: {
          id: 'dataGrid.addColumn.inputs.name.label',
          defaultMessage: 'Name',
          description: 'Data grid add column name input label',
        },
      },
      formula: {
        label: {
          id: 'dataGrid.addColumn.inputs.formula.label',
          defaultMessage: 'Formula',
          description: 'Data grid add column formula input label',
        },
      },
    },
    buttons: {
      cancel: {
        id: 'dataGrid.addColumn.buttons.cancel',
        defaultMessage: 'Cancel',
        description: 'Data grid add column cancel button label',
      },
      save: {
        id: 'dataGrid.addColumn.buttons.save',
        defaultMessage: 'Save',
        description: 'Data grid add column save button label',
      },
    },
  },
  gridActions: {
    view: {
      title: {
        id: 'dataGrid.gridActions.view.title',
        defaultMessage: 'Views',
        description: 'The label of the menu item for the view action',
      },
      settings: {
        id: 'dataGrid.gridActions.view.settings',
        defaultMessage: 'Settings',
        description: 'The label for the settings subheader',
      },
      views: {
        id: 'dataGrid.gridActions.view.views',
        defaultMessage: 'Views',
        description: 'The label for the views subheader',
      },
      showMore: {
        id: 'dataGrid.gridActions.view.showMore',
        defaultMessage: 'Show more',
        description: 'The label for the show more action',
      },
      saveAs: {
        id: 'dataGrid.gridActions.view.saveAs',
        defaultMessage: 'Save as',
        description: 'The label for the save as action',
      },
      manageSettings: {
        id: 'dataGrid.gridActions.view.manageSettings',
        defaultMessage: 'Manage settings',
        description: 'The label for the manage settings action',
      },
      defaultSettings: {
        id: 'dataGrid.gridActions.view.defaultSettings',
        defaultMessage: 'Default settings',
        description: 'The label for the default settings action',
      },
    },
    columnSelection: {
      title: {
        id: 'dataGrid.gridActions.columnSelection.title',
        defaultMessage: 'Columns',
        description: 'The label of the menu item for the column selection action',
      },
    },
    sorting: {
      title: {
        id: 'dataGrid.gridActions.sorting.title',
        defaultMessage: 'Sorting',
        description: 'The label of the menu item for the sorting action',
      },
    },
    dataExport: {
      title: {
        id: 'dataGrid.gridActions.dataExport.title',
        defaultMessage: 'Export',
        description: 'The label of the menu item for the export action',
      },
      currentColumns: {
        id: 'dataGrid.gridActions.dataExport.currentColumns',
        defaultMessage: 'Current columns',
        description: 'The label for the current columns subheader',
      },
      allColumns: {
        id: 'dataGrid.gridActions.dataExport.allColumns',
        defaultMessage: 'All columns',
        description: 'The label for the all columns subheader',
      },
      csv: {
        id: 'dataGrid.gridActions.dataExport.csv',
        defaultMessage: 'CSV',
        description: 'The label for the CSV export action',
      },
      excel: {
        id: 'dataGrid.gridActions.dataExport.excel',
        defaultMessage: 'Excel',
        description: 'The label for the Excel export action',
      },
      pdf: {
        id: 'dataGrid.gridActions.dataExport.pdf',
        defaultMessage: 'PDF',
        description: 'The label for the PDF export action',
      },
    },
    dataImport: {
      title: {
        id: 'dataGrid.gridActions.dataImport.title',
        defaultMessage: 'Import',
        description: 'The label of the menu item for the import action',
      },
    },
    copyGridUrl: {
      title: {
        id: 'dataGrid.gridActions.copyGridUrl.title',
        defaultMessage: 'Copy URL',
        description: 'The label of the menu item for the copy grid url action',
      },
      tooltip: {
        id: 'dataGrid.gridActions.copyGridUrl.tooltip',
        defaultMessage: 'Copied url',
        description: 'The tooltip title of the menu item for the copy grid url action',
      },
    },
  },
  search: {
    placeholder: {
      id: 'dataGrid.search.placeholder',
      defaultMessage: 'Search',
      description: 'Data grid search field placeholder',
    },
    exactMatch: {
      id: 'dataGrid.search.exactMatch',
      defaultMessage: 'Exact math: {state}',
      description: 'Data grid search exact match tooltip',
    },
  },
  selection: {
    button: {
      all: {
        id: 'dataGrid.selection.button.all',
        defaultMessage: 'All',
        description: 'Data grid selection button for selecting all',
      },
    },
    selected: {
      id: 'dataGrid.selection.selected',
      defaultMessage: '{count} of {total} selected',
      description: 'Data grid number of rows selected',
    },
  },
  pagination: {
    currentPageLabel: {
      id: 'dataGrid.pagination.currentPageLabel',
      defaultMessage: 'page {page}',
      description: 'Data grid current page label',
    },
    previousPageLabel: {
      id: 'dataGrid.pagination.previousPageLabel',
      defaultMessage: 'Previous page',
      description: 'Data grid previous page label',
    },
    nextPageLabel: {
      id: 'dataGrid.pagination.nextPageLabel',
      defaultMessage: 'Next page',
      description: 'Data grid next page label',
    },
  },
  exportSelection: {
    title: {
      id: 'dataGrid.exportSelection.title',
      defaultMessage: 'Export',
      description: 'Data grid export selection title',
    },
  },
  views: {
    label: {
      system: {
        id: 'dataGrid.views.label.system',
        defaultMessage: 'System',
        description: 'Data grid view type label system',
      },
      private: {
        id: 'dataGrid.views.label.private',
        defaultMessage: 'Private',
        description: 'Data grid view type label private',
      },
    },
  },
  viewSelection: {
    title: {
      id: 'dataGrid.viewSelection.title',
      defaultMessage: 'Saved views',
      description: 'Data grid view settings title',
    },
    actions: {
      setAsDefault: {
        id: 'dataGrid.viewSelection.actions.setAsDefault',
        defaultMessage: 'Set as default',
        description: 'Data grid view actions set as default',
      },
    },
  },
  viewSelectionMenu: {
    activeView: {
      label: {
        id: 'dataGrid.viewSelectionMenu.activeView.label',
        defaultMessage: 'View',
        description: 'Data grid view selection active view label',
      },
    },
  },
  saveView: {
    title: {
      id: 'dataGrid.saveView.title',
      defaultMessage: 'Save view as',
      description: 'Data grid save view title',
    },
    showViewInformation: {
      button: {
        show: {
          id: 'dataGrid.saveView.showViewInformation.button.show',
          defaultMessage: 'Show view information',
          description: 'Show view information button label',
        },
        hide: {
          id: 'dataGrid.saveView.showViewInformation.button.hide',
          defaultMessage: 'Hide view information',
          description: 'Hide view information button label',
        },
      },
      columns: {
        id: 'dataGrid.saveView.showViewInformation.columns',
        defaultMessage: 'Columns',
        description: 'Show view information columns label',
      },
      filters: {
        id: 'dataGrid.saveView.showViewInformation.filters',
        defaultMessage: 'Filters',
        description: 'Show view information filters label',
      },
      sorting: {
        id: 'dataGrid.saveView.showViewInformation.sorting',
        defaultMessage: 'Sorting',
        description: 'Show view information sorting label',
      },
      itemsPerPage: {
        id: 'dataGrid.saveView.showViewInformation.itemsPerPage',
        defaultMessage: 'Items per page',
        description: 'Show view information items per page label',
      },
    },
    inputs: {
      name: {
        label: {
          id: 'dataGrid.saveView.inputs.name.label',
          defaultMessage: 'Name',
          description: 'Data grid save view name input label',
        },
        helperText: {
          id: 'dataGrid.saveView.inputs.name.helperText',
          defaultMessage: 'Use an existing name to overwrite the settings',
          description: 'Data grid save view name input helper text',
        },
      },
      saveViewForTenant: {
        label: {
          id: 'dataGrid.saveView.inputs.saveViewForTenant.label',
          defaultMessage: 'Available for every user',
          description: 'Data grid save view for tenant input label',
        },
      },
    },
    buttons: {
      cancel: {
        id: 'dataGrid.saveView.buttons.cancel',
        defaultMessage: 'Cancel',
        description: 'Data grid save view cancel button label',
      },
      save: {
        id: 'dataGrid.saveView.buttons.save',
        defaultMessage: 'Save',
        description: 'Data grid save view save button label',
      },
    },
  },
};

export default defineMessages(translations);
